module.exports = __webpack_public_path__ + "img/charman3.24122418.png";